import React from 'react'

const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <h2 className="text-lg font-medium text-gray-900 mb-2">Grid Trading Bot</h2>
        <p className="text-gray-500">Cargando aplicación...</p>
      </div>
    </div>
  )
}

export default LoadingScreen